import { render, staticRenderFns } from "./HealthPlates.vue?vue&type=template&id=75685e66"
import script from "./HealthPlates.vue?vue&type=script&lang=js"
export * from "./HealthPlates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports